<template lang="html">
  <div>
    Contact Us
  </div>
</template>

<script>
export default {
  name: 'contact-us'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue